@use 'styles/functions/rem' as *;
@use 'styles/colors' as *;
@use 'styles/mixins/shadows' as *;

.subscriptionSummaryCardContainer {
    align-items: flex-start;
    border: rem(1px) solid $black;
    border-radius: rem(5px);
    padding: rem(20px) rem(30px);

    @include hoveringShadow;
}
